module.exports = __webpack_public_path__ + "static/img/prize-1-mobile.7a0e90c2.png";